import Slider from 'react-slick';
import { Link } from 'react-router-dom';

import Screenshot01 from '../../assets/img/preview/01.png';
import Screenshot02 from '../../assets/img/preview/02.png';
import Screenshot03 from '../../assets/img/preview/03.png';
import Screenshot04 from '../../assets/img/preview/04.png';
import Screenshot05 from '../../assets/img/preview/05.png';
import Screenshot06 from '../../assets/img/preview/06.png';
import Screenshot07 from '../../assets/img/preview/07.png';

import './styles.css';

const Preview = () =>{
  const settings = {
    dots: true,
    infinite: true,
    speed: 1500,
    slidesToShow: 2,
    autoplay: true,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 1
        }
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      }
    ]
  };
  var year = new Date().getFullYear();

  return(
    <>
    <div className="container-fluid header-preview bg-primary text-white d-flex align-items-center flex-wrap">
      <div className="col-12 col-lg-6">
          <h1 className="title-responsive">
            Bang - App Landing Template
          </h1>
          <h5>- Bootstrap v4.6</h5>
          <h5>- Mobile Responsive</h5>
          <h5>- Clean and unique design</h5>
          <h5>- Google fonts support</h5>
      </div>
      <div className="col-12 col-lg-6">
        <Slider
        {...settings}>
          <div className="col-12 p-1">
            <img
            src={Screenshot01}
            alt=""
            className="img-fluid border border-white"
            />
          </div>
          <div className="col-12 p-1">
            <img
            src={Screenshot02}
            alt=""
            className="img-fluid border border-white"
            />
          </div>
          <div className="col-12 p-1">
            <img
            src={Screenshot03}
            alt=""
            className="img-fluid border border-white"
            />
          </div>
          <div className="col-12 p-1">
            <img
            src={Screenshot04}
            alt=""
            className="img-fluid border border-white"
            />
          </div>
          <div className="col-12 p-1">
            <img
            src={Screenshot05}
            alt=""
            className="img-fluid border border-white"
            />
          </div>
        </Slider>
      </div>
    </div>
    <div className="division3">
      <h1 className="title-responsive text-center text-primary">
        Homepages
      </h1>
        <div className="container division2 d-flex flex-wrap">
          <Link
          to="/home01"
          className="col-12 col-lg-4 mt-5 mt-lg-0">
            <div className="col-12 p-0">
              <img
              src={Screenshot01}
              alt="..."
              className="img-fluid border border-primary"
              style={{borderRadius: '5px'}}
              />
              <h3 className="text-dark mt-3 font-weight-bold text-center">
                Homepage01
              </h3>
            </div>
          </Link>
          <Link
          to="/home02"
          className="col-12 col-lg-4 mt-5 mt-lg-0">
            <div className="col-12 p-0">
              <img
              src={Screenshot02}
              alt="..."
              className="img-fluid border border-primary"
              style={{borderRadius: '5px'}}
              />
              <h3 className="text-dark mt-3 font-weight-bold text-center">
                Homepage02
              </h3>
            </div>
          </Link>
        </div>
    </div>
    <div className="division3">
      <h1 className="title-responsive text-center text-primary">
        Blog Pages
      </h1>
        <div className="container division2 d-flex flex-wrap">
          <Link
          to="/blog01"
          className="col-12 col-lg-4 mt-5 mt-lg-0">
            <div className="col-12 p-0">
              <img
              src={Screenshot03}
              alt="..."
              className="img-fluid border border-primary"
              style={{borderRadius: '5px'}}
              />
              <h3 className="text-dark mt-3 font-weight-bold text-center">
                Blog Grid01
              </h3>
            </div>
          </Link>
          <Link
          to="/blog02"
          className="col-12 col-lg-4 mt-5 mt-lg-0">
            <div className="col-12 p-0">
              <img
              src={Screenshot04}
              alt="..."
              className="img-fluid border border-primary"
              style={{borderRadius: '5px'}}
              />
              <h3 className="text-dark mt-3 font-weight-bold text-center">
                Blog Grid02
              </h3>
            </div>
          </Link>
          <Link
          to="/blog/details"
          className="col-12 col-lg-4 mt-5 mt-lg-0">
            <div className="col-12 p-0">
              <img
              src={Screenshot05}
              alt="..."
              className="img-fluid border border-primary"
              style={{borderRadius: '5px'}}
              />
              <h3 className="text-dark mt-3 font-weight-bold text-center">
                Blog Details
              </h3>
            </div>
          </Link>
        </div>
    </div>
    <div className="division3">
      <h1 className="title-responsive text-center text-primary">
        Extra Pages
      </h1>
        <div className="container division2 d-flex flex-wrap">
          <Link
          to="/doiasdasçl~djksa"
          className="col-12 col-lg-4 mt-5 mt-lg-0">
            <div className="col-12 p-0">
              <img
              src={Screenshot06}
              alt="..."
              className="img-fluid border border-primary"
              style={{borderRadius: '5px'}}
              />
              <h3 className="text-dark mt-3 font-weight-bold text-center">
                404
              </h3>
            </div>
          </Link>
          <Link
          to="/mail"
          className="col-12 col-lg-4 mt-5 mt-lg-0">
            <div className="col-12 p-0">
              <img
              src={Screenshot07}
              alt="..."
              className="img-fluid border border-primary"
              style={{borderRadius: '5px'}}
              />
              <h3 className="text-dark mt-3 font-weight-bold text-center">
                Mail Success
              </h3>
            </div>
          </Link>
        </div>
    </div>
    <footer className="bg-primary">
      <p className="text-white text-center py-2 division">All rights reserved to legit code {year}</p>
    </footer>
    </>
  );
};
export default Preview;